import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	tooltip: {
		id: 'servicedesk-board-button.tooltip',
		defaultMessage: 'Board insights',
		description: 'Tooltip describing the content that the button toggles',
	},
});
